<template>
    <div>
        <h3 class="text-center" v-if="isUpdate && !enableUpdate">Modifica abbonamento al momento non disponibile!</h3>
            <h3 class="text-center" v-else-if="isUpdate && enableUpdate && !errorLoading">Stai per essere reindirizzato sul tuo account!</h3>
            <h3 class="text-center" v-else-if="isUpdate && errorLoading">Errore caricamento abbonamento!<br>Contatta un amministratore</h3>
            <h3 class="text-center" v-else>Stai per essere reindirizzato sul Carrello!</h3>
        </div>
</template>

<script>
import { isNil } from "lodash";

export default {
    name: "ClosedStep",
    computed: {
        errorLoading(){
            return isNil(this.$store.getters.abbonamento_active);
        }
    },
    mounted(){
        this.log('abbonamento_active',this.$store.getters.abbonamento_active, this.errorLoading);
        this.GTM_trackView("Step chiusura abbonamento", "/abbonamento#step6");
    }
};
</script>